import React, { useState } from 'react'
import { Table, Tag } from 'antd'
import { gql, useQuery } from '@apollo/client'
import moment from 'moment'

const GET_DISPATCHES = gql`
  query notificationDispatches($page: Int, $limit: Int) {
    notificationDispatches(page: $page, limit: $limit) {
      items {
        id
        headingRU
        headingKZ
        segment {
          mode
          version
          comparison
          lastActiveDays
          language
        }
        targetCount
        successCount
        failureCount
        status
        finishedAt
        initiatorName
        created_at
      }
      total
    }
  }
`

const MODE_LABELS = {
  broadcast: 'Всем',
  appVersion: 'По версии',
  lastActive: 'По активности'
}

const COMPARISON_LABELS = {
  equal: '=',
  greater: '>',
  lower: '<'
}

const describeSegment = segment => {
  if (!segment) return '—'
  const parts = [MODE_LABELS[segment.mode] || segment.mode]
  if (segment.mode === 'appVersion') {
    parts.push(
      `${COMPARISON_LABELS[segment.comparison] || '='} ${segment.version}`
    )
  }
  if (segment.mode === 'lastActive') {
    parts.push(
      segment.comparison === 'lower'
        ? `неактивны > ${segment.lastActiveDays} дн.`
        : `активны за ${segment.lastActiveDays} дн.`
    )
  }
  if (segment.language) parts.push(segment.language.toUpperCase())
  return parts.join(', ')
}

const STATUS_TAGS = {
  sending: { color: 'processing', label: 'Идёт отправка' },
  completed: { color: 'green', label: 'Завершено' },
  failed: { color: 'red', label: 'Ошибка' }
}

const renderStatus = status => {
  const tag = STATUS_TAGS[status]
  if (!tag) return '—'
  return <Tag color={tag.color}>{tag.label}</Tag>
}

const renderCount = (value, item) => (item.status === 'sending' ? '—' : value)

const PAGE_SIZE = 20

const DispatchHistory = () => {
  const [page, setPage] = useState(1)
  const { data, loading } = useQuery(GET_DISPATCHES, {
    variables: { page, limit: PAGE_SIZE },
    fetchPolicy: 'network-only',
    pollInterval: 10000
  })

  const columns = [
    {
      title: 'Дата',
      dataIndex: 'created_at',
      render: value => moment(value).format('DD.MM.YYYY HH:mm')
    },
    {
      title: 'Заголовок (рус)',
      dataIndex: 'headingRU'
    },
    {
      title: 'Сегмент',
      dataIndex: 'segment',
      render: describeSegment
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      render: renderStatus
    },
    {
      title: 'Целей',
      dataIndex: 'targetCount'
    },
    {
      title: 'Успешно',
      dataIndex: 'successCount',
      render: renderCount
    },
    {
      title: 'Ошибок',
      dataIndex: 'failureCount',
      render: renderCount
    },
    {
      title: 'Отправил',
      dataIndex: 'initiatorName',
      render: value => value || '—'
    }
  ]

  return (
    <Table
      dataSource={data?.notificationDispatches?.items || []}
      columns={columns}
      rowKey={item => item.id}
      loading={loading}
      pagination={{
        current: page,
        pageSize: PAGE_SIZE,
        total: data?.notificationDispatches?.total || 0,
        onChange: setPage
      }}
    />
  )
}

export default DispatchHistory
